import { createSelector } from 'reselect';
import type { RootState } from '@/app/store';

export const selectCall = (state: RootState): RootState['call'] => state.call;
export const selectActiveBeneficiary = createSelector(selectCall, (c) => c.activeBeneficiary);
export const selectCallConnected = createSelector(selectCall, (c) => c.connected);
